// =========================================================
// frontend/js/heatmap.js - V13.2 (Strict Filtering & Event Styles Fix)
// =========================================================
// Globaler State für den Ansichts-Modus (Kompakt vs. Split)
if (typeof window.heatmapViewMode === 'undefined') window.heatmapViewMode = 'split';
window.toggleHeatmapViewMode = function() {
    window.heatmapViewMode = window.heatmapViewMode === 'split' ? 'compact' : 'split';
    window.render();
};
window.renderTeamHeatmap = function() {
    const year = window.currentDate.getFullYear();
    const month = window.currentDate.getMonth();
    const monthName = typeof getMonthName === 'function' ? getMonthName(window.currentDate) : window.currentDate.toLocaleString('de-DE', {
        month: 'long'
    });
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const allUsers = window.usersList || [];
    const allEvents = window.events || [];
    const u = window.currentUser;
    const isOnlyMe = window.showOnlyMe === true;
    const isSplitView = window.heatmapViewMode === 'split';
    // 1. Prioritäts-Liste des Users laden (mit Fallback)
    const userPriorities = u?.prefs?.eventPriorities || [
        'HO',
        'vacation',
        'sick',
        'admin_event'
    ];
    const sortEventsByPriority = (eventsArray)=>{
        return eventsArray.sort((a, b)=>{
            let idxA = userPriorities.indexOf(a.type);
            let idxB = userPriorities.indexOf(b.type);
            if (idxA === -1) idxA = 999;
            if (idxB === -1) idxB = 999;
            return idxA - idxB;
        });
    };
    const normalize = (str)=>{
        if (!str) return "";
        return str.toLowerCase().trim().replace(/ß/g, 'ss').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
    };
    const searchTerm = normalize(window.calendarSearchTerm);
    let usersToDisplay = isOnlyMe ? allUsers.filter((userObj)=>userObj.uid === u?.uid) : allUsers;
    if (searchTerm) usersToDisplay = usersToDisplay.filter((user)=>{
        const fullName = normalize(`${user.firstName} ${user.lastName}`);
        const hasMatchingEvent = allEvents.some((e)=>{
            const d = new Date(e.date);
            if (d.getMonth() !== month || d.getFullYear() !== year) return false;
            // Für die Suche: Nur eigene Events oder Globale prüfen
            if (e.userId !== user.uid && !(typeof window.isAdminEventVisibleToUser === 'function' ? window.isAdminEventVisibleToUser(e, user.nodeId) : e.type === 'admin_event' || e.isGlobal === true || e.blocksWorking === true)) return false;
            const typeName = normalize(e.typeName || e.type || '');
            const comment = normalize(e.comment || '');
            return typeName.includes(searchTerm) || comment.includes(searchTerm);
        });
        return fullName.includes(searchTerm) || hasMatchingEvent;
    });
    let html = `
        <div class="overflow-x-auto p-4 animate-fadeIn">
            <table class="w-full border-collapse">
                <thead>
                    <tr class="bg-slate-800 text-white">
                        <th colspan="${daysInMonth + 1}" class="p-3 relative rounded-t-2xl">
                            <span class="text-[10px] font-black uppercase tracking-[0.3em]">Matrix: ${monthName} ${year}</span>
                            
                            <div class="absolute right-4 top-1/2 -translate-y-1/2 flex bg-slate-700 p-1 rounded-lg border border-slate-600 shadow-inner">
                                <button onclick="window.toggleHeatmapViewMode()" class="px-3 py-1 rounded-md text-[9px] font-black uppercase transition-all ${!isSplitView ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-400 hover:text-white'}">Kompakt</button>
                                <button onclick="window.toggleHeatmapViewMode()" class="px-3 py-1 rounded-md text-[9px] font-black uppercase transition-all ${isSplitView ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-400 hover:text-white'}">Split</button>
                            </div>
                        </th>
                    </tr>
                    <tr class="bg-slate-50">
                        <th class="p-4 border-b border-r border-slate-200 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest min-w-[200px] sticky left-0 bg-slate-50 z-20">Mitarbeiter</th>
                        ${Array.from({
        length: daysInMonth
    }, (_, i)=>i + 1).map((d)=>{
        const date = new Date(year, month, d);
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;
        return `<th class="p-2 border-b border-slate-200 text-[10px] font-black min-w-[40px] ${isWeekend ? 'bg-slate-100 text-slate-400' : 'text-slate-600'}">${d}</th>`;
    }).join('')}
                    </tr>
                </thead>
                <tbody>
    `;
    if (usersToDisplay.length === 0) {
        const msg = searchTerm ? `Keine Treffer f\xfcr "${window.calendarSearchTerm}".` : "Keine Mitarbeiter gefunden.";
        html += `<tr><td colspan="${daysInMonth + 1}" class="p-8 text-center text-slate-400 font-bold italic">${msg}</td></tr>`;
    }
    usersToDisplay.forEach((user)=>{
        const initials = typeof window.getUserInitials === 'function' ? window.getUserInitials(user.firstName, user.lastName) : (user.firstName?.[0] || '') + (user.lastName?.[0] || '');
        html += `
            <tr class="hover:bg-slate-50/50 transition-colors group">
                <td class="p-4 border-b border-r border-slate-100 sticky left-0 bg-white z-10 shadow-[4px_0_8px_-4px_rgba(0,0,0,0.05)] group-hover:bg-slate-50">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-lg bg-slate-100 text-slate-600 flex items-center justify-center text-[10px] font-bold border border-slate-200 shrink-0">
                            ${initials}
                        </div>
                        <span class="font-bold text-slate-700 text-sm truncate">${user.firstName} ${user.lastName}</span>
                    </div>
                </td>
        `;
        for(let d = 1; d <= daysInMonth; d++){
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
            // --- FIX: Strenger Filter für die Zeilen-Zellen ---
            let eventsToday = allEvents.filter((e)=>{
                if (e.date !== dateStr || e.status === 'REJECTED') return false;
                // 1. Eigene Einträge des jeweiligen Benutzers in DIESER Zeile
                if (e.userId === user.uid) return true;
                // 2. Nur echte GLOBALE Firmen-Events (Feiertage, etc.) anzeigen
                // Wir nutzen die isAdminEventVisibleToUser Funktion aus der calendar.js
                if (typeof window.isAdminEventVisibleToUser === 'function') return window.isAdminEventVisibleToUser(e, user.nodeId);
                // Fallback falls Funktion nicht geladen:
                return e.type === 'admin_event' || e.isGlobal === true || e.blocksWorking === true;
            });
            if (searchTerm && eventsToday.length > 0) eventsToday = eventsToday.filter((e)=>{
                const typeNormal = normalize(e.typeName || e.type || '');
                const commentNormal = normalize(e.comment || '');
                const nameNormal = normalize(`${user.firstName} ${user.lastName}`);
                return typeNormal.includes(searchTerm) || commentNormal.includes(searchTerm) || nameNormal.includes(searchTerm);
            });
            const date = new Date(year, month, d);
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;
            let content = '';
            if (eventsToday.length > 0) {
                eventsToday = sortEventsByPriority(eventsToday);
                const tooltipText = eventsToday.map((e)=>{
                    // FIX: Nutzt jetzt die smarte getCalendarStyleForEvent, um SubTypen zu erkennen
                    let s = typeof window.getCalendarStyleForEvent === 'function' ? window.getCalendarStyleForEvent(e) : {
                        name: 'Eintrag'
                    };
                    return `${s.name}${e.status === 'PENDING' ? ' (Ausstehend)' : ''}${e.staffingWarning ? ' (Warnung)' : ''}`;
                }).join(' | ');
                const ev1 = eventsToday[0];
                const st1 = typeof window.getCalendarStyleForEvent === 'function' ? window.getCalendarStyleForEvent(ev1) : getFallbackStyle(ev1.type);
                const isPending1 = ev1.status === 'PENDING';
                const isWarning1 = ev1.staffingWarning === true;
                const color1 = st1.customHex || '#3b82f6';
                let styleClass1 = '';
                if (isPending1) styleClass1 = 'border-[1.5px] border-dashed border-slate-400 bg-transparent opacity-60 animate-pulse';
                else if (isWarning1) styleClass1 = 'border-2 border-rose-400';
                // Box-Background: Wenn es Pending ist, zeige den Rahmen in Farbe, aber Hintergrund durchsichtig
                const styleProp1 = isPending1 ? `border-color: ${color1}; color: ${color1};` : `background-color: ${color1}; color: white;`;
                if (eventsToday.length === 1 || !isSplitView) {
                    const badge = eventsToday.length > 1 ? `<div class="absolute -top-1.5 -right-1.5 bg-slate-800 text-white text-[8px] font-black w-4 h-4 rounded-full flex items-center justify-center border border-white shadow-sm z-10">+${eventsToday.length - 1}</div>` : '';
                    content = `
                        <div class="relative w-7 h-7 mx-auto rounded-lg shadow-sm transition-transform hover:scale-110 cursor-help flex items-center justify-center ${styleClass1}" 
                             style="${styleProp1}" title="${tooltipText}">
                            <i data-lucide="${st1.icon || 'calendar'}" class="w-3.5 h-3.5 ${isPending1 ? '' : 'text-white'}"></i>
                            ${badge}
                        </div>
                    `;
                } else {
                    const ev2 = eventsToday[1];
                    const st2 = typeof window.getCalendarStyleForEvent === 'function' ? window.getCalendarStyleForEvent(ev2) : getFallbackStyle(ev2.type);
                    const color2 = st2.customHex || '#f97316';
                    const badge = eventsToday.length > 2 ? `<div class="absolute -top-1.5 -right-1.5 bg-slate-800 text-white text-[8px] font-black w-4 h-4 rounded-full flex items-center justify-center border border-white shadow-sm z-10">+${eventsToday.length - 2}</div>` : '';
                    content = `
                        <div class="relative w-8 h-8 mx-auto rounded-lg shadow-sm transition-transform hover:scale-110 cursor-help overflow-hidden ${styleClass1}" 
                             style="${isPending1 ? `border-color: ${color1}` : `background: linear-gradient(135deg, ${color1} 50%, ${color2} 50%)`}" title="${tooltipText}">
                            <i data-lucide="${st1.icon || 'calendar'}" class="w-3 h-3 ${isPending1 ? '' : 'text-white'} absolute top-1 left-1"></i>
                            <i data-lucide="${st2.icon || 'calendar'}" class="w-3 h-3 ${isPending1 ? '' : 'text-white'} absolute bottom-1 right-1"></i>
                            <div class="absolute inset-0 border-[0.5px] border-white/20 transform rotate-45 scale-150 pointer-events-none"></div>
                            ${badge}
                        </div>
                    `;
                }
            }
            html += `
                <td onclick="${user.uid === window.currentUser?.uid ? `typeof window.openBookingModal === 'function' ? window.openBookingModal('${dateStr}') : null` : ''}" 
                    class="p-1 border-b border-slate-100 text-center ${isWeekend ? 'bg-slate-50/30' : ''} ${user.uid === window.currentUser?.uid ? 'cursor-pointer hover:bg-blue-50/30' : ''}">
                    ${content}
                </td>
            `;
        }
        html += `</tr>`;
    });
    return html + `</tbody></table></div>`;
};
function getFallbackStyle(typeStr) {
    const t = (typeStr || '').toUpperCase();
    if (t.includes('HO') || t.includes('HOME')) return {
        customHex: '#3b82f6',
        icon: 'home',
        name: 'Homeoffice'
    };
    if (t.includes('VAC') || t.includes('URLAUB')) return {
        customHex: '#10b981',
        icon: 'palmtree',
        name: 'Urlaub'
    };
    if (t.includes('SICK') || t.includes('KRANK')) return {
        customHex: '#f43f5e',
        icon: 'thermometer',
        name: 'Krank'
    };
    return {
        customHex: '#94a3b8',
        icon: 'calendar',
        name: 'Eintrag'
    };
}

//# sourceMappingURL=frontend.cd9bd278.js.map
